var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"min-height":"300px"}},[_c('vue-affix-box',{attrs:{"z-index":11}},[_c('my-header',{attrs:{"menus":_vm.menuList}})],1),_c('div',{staticStyle:{"padding":"20px 20px"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }